import { TFunction } from 'i18next'
import { z } from 'zod'

import { importedInvoiceReviewFormShapeSchema } from '../types/importedInvoiceReviewFormSchema'
import { getImportedInvoiceReviewApprovableSchema } from './getImportedInvoiceReviewApprovableSchema'
import { parseImportedInvoiceReviewApprovable } from './parseImportedInvoiceReviewApprovable'

/** Reports the approve contract's issues on the form fields they belong to. */
export const getImportedInvoiceReviewFormSchema = (t: TFunction) => {
  const approvableSchema = getImportedInvoiceReviewApprovableSchema(t)

  return importedInvoiceReviewFormShapeSchema.superRefine((values, context) => {
    const { lineIndexesToCheck, result } = parseImportedInvoiceReviewApprovable(approvableSchema, values)

    if (result.success) {
      return
    }

    for (const issue of result.error.issues) {
      const [field, index, ...rest] = issue.path
      let path = issue.path

      if (field === 'lines' && typeof index === 'number') {
        path = ['lines', lineIndexesToCheck[index], ...rest]
      } else if (field === 'client') {
        path = ['client']
      }

      context.addIssue({ code: z.ZodIssueCode.custom, message: issue.message, path })
    }
  })
}
